import { useState } from "react";
import { Carousel, CarouselItem, Col, Row } from "reactstrap";

interface Props {
    data : any[];
    renderer : (item : any) => JSX.Element;
    activeIndex : number;
    setActiveIndex : (index : number) => void;
    colSize : number;
}

export default function CarouselRenderer({ data, renderer, activeIndex, setActiveIndex, colSize = 3 } : Props) {
    const [animating, setAnimating] = useState<boolean>(false);
    const next = () => {
        if (animating) return;
        const nextIndex =
        activeIndex === data.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating) return;
        const nextIndex =
        activeIndex === 0 ? data.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const slides = data.map((items, index) => (
        <CarouselItem 
            key={index}
            className="" 
            active={index === activeIndex}
            onExited={() => setAnimating(false) }
            onExiting={() => setAnimating(true)}
        >
            
            <Row className="d-flex flex-row justify-content-evenly">
            {
                items.map((item : any, index : number) => (
                    <Col md={colSize} key={index}>
                        {renderer(item)}
                    </Col>
                    
                ))
            }
            </Row>
        </CarouselItem>
    ));

  return (
    <>
        {
          slides.length > 0 &&
          <Carousel
          activeIndex={activeIndex}
          next={next}
          previous={previous}
          interval={null}
          >
            {slides}
            {
                activeIndex !== 0 &&
                <div className="carousel-control-prev" style={{maxWidth:"32px"}} onClick={previous}>
                <i
                    className="fas fa-chevron-circle-left"
                    style={{ fontSize: "2rem", color: "black" }}
                ></i> {slides.length}
                </div>
            }
            {
                activeIndex !== slides.length - 1 &&
                <div className="carousel-control-next" style={{maxWidth:"32px"}} onClick={next}>
                <i
                    className="fas fa-chevron-circle-right"
                    style={{ fontSize: "2rem", color: "black" }}
                ></i>
                </div>
            }
          </Carousel> 
        }
    </>
  );
}
